// Copyright © 2024 Broadcom Inc. and its subsidiaries. All Rights Reserved.
import get from 'lodash/get';

const styles = ({ color, margin, padding }) => ({
  statusBar: {
    margin: `${get(margin, 'm5')} 0 ${get(margin, 'm10')} 0`,
    '& span': {
      position: 'relative',
      display: 'inline-block',
      padding: `0 ${get(padding, 'p16')}`,
    },
    float: 'left',
  },
  inline: {
    display: 'inline-block',
  },
  status: {
    '&:before': {
      display: 'inline-block',
      position: 'absolute',
      content: '""',
      left: 0,
      top: '50%',
      marginTop: '-6px',
      height: '10px',
      width: '10px',
      borderRadius: '10px',
    },
  },
  success: {
    color: get(color, 'success'),
    '&:before': {
      backgroundColor: get(color, 'success'),
    },
  },
  error: {
    color: get(color, 'error'),
    '&:before': {
      backgroundColor: get(color, 'error'),
    },
  },
  deprecated: {
    color: '#f7922f',
    '&:before': {
      backgroundColor: '#f7922f',
    },
  },
  disabled: {
    color: '#b3bdc2',
    '&:before': {
      backgroundColor: '#b3bdc2',
    },
  },
  new: {
    color: '#20465f',
    '&:before': {
      backgroundColor: '#20465f',
    },
  },
  disabledGraphic: {
    color: get(color, 'disabledGraphic'),
    '&:before': {
      backgroundColor: get(color, 'disabledGraphic'),
    },
  },
  changeButton: {
    textTransform: 'none',
    color: get(color, 'primaryButtonBackground'),
    backgroundColor: get(color, 'primaryButtonText'),
    borderColor: get(color, 'primaryButtonBackground'),
    borderRadius: 3,
    padding: '0',
  },
  changeContainer: {
    padding: '0 !important',
  },
});

export default styles;
